import alt from 'components/Dispatcher';
import DepartmentSource from 'sources/DepartmentSource';
import generateAsyncActions from 'utils/generateAsyncActions';
import {browserHistory} from 'react-router';
import {List} from 'immutable';
import {ActionsBase, DispatchAll, IncludeResultCallbacks} from '@store/@types/alt';
import Department, {DepartmentId} from 'records/Department';

interface AsyncActions {
  createDepartment(department: Department): Promise<Department>;
  fetchDepartment(departmentId: DepartmentId): Promise<Department>;
  fetchDepartmentProfiles(isAdmin: boolean): Promise<List<Department>>;
  fetchUserDepartment(): Promise<Department>;
  updateDepartment(department: Department): Promise<Department>;
  deleteDepartment(department: Department): Promise<void>;
}

interface SyncActions {
  updateSelectedDepartment;
  editDepartment;
}

export interface DepartmentActionsInterface
  extends IncludeResultCallbacks<AsyncActions>,
    SyncActions {}

class DepartmentActions
  extends ActionsBase<AsyncActions, SyncActions>()
  implements DispatchAll<AsyncActions>
{
  constructor() {
    super();
    this.generateActions(
      'updateSelectedDepartment',
      'editDepartment',
      ...generateAsyncActions(
        'createDepartment',
        'fetchDepartment',
        'fetchDepartmentProfiles',
        'fetchUserDepartment',
        'updateDepartment',
        'deleteDepartment'
      )
    );
  }

  createDepartment(department) {
    return dispatch => {
      dispatch(department);
      DepartmentSource.createDepartment(department).then(department => {
        this.createDepartmentSuccess(department);
        browserHistory.push(`/admin/departments/edit/${department.id}`);
      }, this.createDepartmentError);
    };
  }

  fetchDepartment(departmentId) {
    return dispatch => {
      dispatch(departmentId);
      DepartmentSource.fetchDepartment(departmentId).then(
        this.fetchDepartmentSuccess,
        this.fetchDepartmentError
      );
    };
  }

  fetchDepartmentProfiles(isAdmin) {
    return dispatch => {
      dispatch();
      return DepartmentSource.fetchDepartmentProfiles(isAdmin).then(
        this.fetchDepartmentProfilesSuccess,
        this.fetchDepartmentProfilesError
      );
    };
  }

  fetchUserDepartment() {
    return dispatch => {
      dispatch();
      return DepartmentSource.fetchUserDepartment().then(
        this.fetchUserDepartmentSuccess,
        this.fetchUserDepartmentError
      );
    };
  }

  updateDepartment(department) {
    return dispatch => {
      dispatch(department);
      return DepartmentSource.updateDepartment(department).then(
        this.updateDepartmentSuccess,
        this.updateDepartmentError
      );
    };
  }

  deleteDepartment(department) {
    return dispatch => {
      dispatch(department);
      return DepartmentSource.deleteDepartment(department).then(
        this.deleteDepartmentSuccess,
        this.deleteDepartmentError
      );
    };
  }
}

export default alt.createActions<AsyncActions, SyncActions>(DepartmentActions);
